import React, { useState } from 'react';
import Modal from '../../../BaseComponents/Modal';
import Button from '../../../BaseComponents/Button';
import { Quote, deleteQuote } from '../../../../api/quotes';
import { toast } from 'react-toastify';
import './QuotesModal.scss';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  quoteToDelete: Quote | null;
  onQuoteDeleted: (quote: Quote) => Promise<void> | void;
};

const DeleteQuoteModal: React.FC<Props> = ({ 
  isOpen, 
  onClose, 
  quoteToDelete, 
  onQuoteDeleted 
}) => {
  const [loading, setLoading] = useState<boolean>(false);

  const onDeleteClick = async () => {
    if (!quoteToDelete) return;
    
    setLoading(true);
    try {
      await deleteQuote(quoteToDelete.id);
      toast.success('Quote deleted successfully');
      onQuoteDeleted(quoteToDelete);
      onClose();
    } catch (error: any) {
      console.log('error :>> ', error);
      toast.error(error?.message || 'Failed to delete quote');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      width="420px"
    >
      <div className="delete-block-container" style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        <div className="modal-header" style={{ textAlign: 'center' }}>
          <div className="title" style={{ fontSize: '18px', fontWeight: 600, color: '#374151', marginBottom: '8px' }}>
            Are you sure you want to delete this quote?
          </div>
        </div>

        <div className="submit-btn-wrapper" style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <Button
            text="No"
            onClick={onClose}
          />
          <Button 
            text="Yes" 
            onClick={onDeleteClick} 
            isLoading={loading} 
          />
        </div>
      </div>
    </Modal>
  );
};

export default DeleteQuoteModal;
